export const tariffData2AggregatedRows = (data) => {
  // console.log(data);
  const tariffDetails = data?.tariffDetails;
  const taxes = tariffDetails?.taxes;
  const metersInfo = tariffDetails?.metersInfo;
  let finalArray = [];

  if (Array.isArray(metersInfo) && metersInfo.length > 0) {
    metersInfo.map((obj) => {
      const foundTax = taxes.find((tax) => tax.meteringPointId === obj.meter);
      let mergedObject = {
        ...obj,
        ...foundTax,
      };
      delete mergedObject.nettariffHourly;
      delete mergedObject.rabatNettariffHourly;
      finalArray.push(mergedObject);
    });
  }
  return finalArray;
};
